
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benchmarking/s/[[...query]]",
      function () {
        return require("private-next-pages/benchmarking/s/[[...query]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benchmarking/s/[[...query]]"])
      });
    }
  